import { Component, OnInit, Inject  } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProductsComponent implements OnInit {

  ShowDeleteProductQuestion:boolean;
  Filter: {[k: string]: any} = {};
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  ProductsSearchOn:boolean;
  SearchTerm:string = "";
  masterData:any;
  Products:any[];
  resultsLength:number;
  pageSize:number = 50;
  loadingSearchProducts:boolean;

  currentProduct:any;
  currentProductToDelete:any;

  Administration:any;
  ProductGeneralType:any;
  AllSelected:boolean;
  ImportProductsQuestion:boolean;
  UpdateSearchResultsQuestion:boolean;

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router) { }

  ngOnInit(): void {
    this.GetInvoiceMasterData();
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Partner = {};
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;
    this.Filter.DecimalPrecision = {};
    this.Filter.DecimalPrecision = null;

    this.Filter.Type = {};
    this.Filter.Type = null;

    this.Filter.BankAccount = {};
    this.Filter.BankAccount = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 10;
    this.Filter.Pager.TotalCount = 0;
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.masterData = response;
        this.Administration = this.masterData.Administrations[0];
      }
   
      this.InitializeFilter();
      this.SearchProducts(true);
      this.parent.loading = false;
    });
  }

  GetProductsFiltered(){
    var request = {
      SearchTerm:this.SearchTerm,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      AdministrationID:this.Administration.ID
    };

    this.parent.loading = true;

    this.service.GetProductsFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Products = response["Products"];
       this.resultsLength = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }

  compareFirst(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  SearchProducts(initialize = false){

    var request = {
      SearchTerm:this.SearchTerm,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:this.Administration.ID,
      ProductGeneralTypeID:this.ProductGeneralType?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager.PageSize,
      IncludeStock:false,
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      InvoiceMasterData:this.masterData,
      DecimalPrecision:this.masterData.DecimalPrecisions[0],
    };

    if(this.SearchTerm.length >= 0 || initialize == true){
      this.loadingSearchProducts = true;

      this.service.SuggestProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
            this.Products = response["Products"];
            this.resultsLength = response["Count"];
        }
     
        this.loadingSearchProducts = false;
      });

      this.SearchProductsCOUNT(initialize);
    }
  }

  SearchProductsCOUNT(initialize = false){

    var request = {
      SearchTerm:this.SearchTerm,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:this.Administration.ID,
      ProductGeneralTypeID:this.ProductGeneralType?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager.PageSize,
      IncludeStock:false,
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      InvoiceMasterData:this.masterData,
      DecimalPrecision:this.masterData.DecimalPrecisions[0],
    };

    if(this.SearchTerm.length >= 0 || initialize == true){
      this.loadingSearchProducts = true;

      this.service.SuggestProductsCOUNT(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.Filter.Pager = response["Pager"];
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  SelectAll(){
    this.Products.forEach(p => {
      p.IsSelected = this.AllSelected;
    });

    this.UpdateNumberOfSelectedItems();
  }

  DeleteProduct(){
    var request = {
      ProductID:this.currentProductToDelete.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
   
      this.loadingSearchProducts = true;

      this.service.DeleteProduct(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.SearchProducts(true);
        }
     
        this.currentProductToDelete = null;
        this.loadingSearchProducts = false;
      });
  }

  GetDeleteProductPossibility(p:any){
    var request = {
      ProductID:p.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
   
      this.loadingSearchProducts = true;

      this.service.GetDeleteProductPossibility(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.ShowDeleteProductQuestion = true;
          this.currentProductToDelete = p;
        }
     
        this.loadingSearchProducts = false;
      });
  }

  UpdateProduct(p:any){
    var request = {
      ID:p.ID,
      Name:p.Name,
      Code:p.Code,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
   
      this.loadingSearchProducts = true;

      this.service.UpdateProduct(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
        }
     
        this.loadingSearchProducts = false;
      });
  }

  ProductEvents:any[];
  auxProduct:any;

  GetProductHistoryEvents(p:any){
    var request = {
      ProductID:p.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
   
      this.auxProduct = p;
      this.loadingSearchProducts = true;

      this.service.GetProductHistoryEvents(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.ProductEvents = response["Events"];
          this.ShowProductHistoryEventsContainer = true;
        }
     
        this.loadingSearchProducts = false;
      });
  }

  ShowProductHistoryEventsContainer:boolean;

  ImportProductsFromConnectedService(ServiceName:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ServiceName:ServiceName,
      SearchTerm:this.SearchTerm
    };

    this.parent.loading = true;

    this.service.ImportProductsFromConnectedService(request).subscribe(response => {
     
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }
     
      this.parent.loading = false;
    });
  }

  SelectedItems:number;
  ShowMergeProducts:boolean;
  SelectedProducts:any[];
  TargetProduct:any;

  UpdateNumberOfSelectedItems(){
    this.SelectedProducts = [];
    this.SelectedItems = 0;
    this.Products.forEach(element => {
      if(element.IsSelected){
        this.SelectedItems++;
        this.SelectedProducts.push(element);
      }
    });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  MergeProducts(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      MergingProducts:this.SelectedProducts,
      TargetProduct:this.TargetProduct
      };
   
      this.loadingSearchProducts = true;

      this.service.MergeProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          this.GetProductsFiltered();
        }
     
        this.loadingSearchProducts = false;
      });
  }

  UpdateProductsSearchResults(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      };
   
      this.loadingSearchProducts = true;

      this.service.UpdateProductsSearchResults(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
     
        this.loadingSearchProducts = false;
      });
  }
}
